/**
 * @date: 2022-04-19
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */


import React, {useEffect, useState} from 'react'
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {CustomBackdrop} from "../utils/customStyles";
import ShowSnackbar from "../utils/ShowSnackbar";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import {Container, styled, TableCell, tableCellClasses, TableContainer} from "@mui/material";
import Paper from "@mui/material/Paper";
import {convertDateToTimeString} from "../utils/cert-helper";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    // [`&.${tableCellClasses.head}`]: {
    //     backgroundColor: theme.palette.primary.main,
    //     color: theme.palette.common.white,
    // },
    // [`&.${tableCellClasses.body}`]: {
    //     fontSize: 14,
    // },
    fontWeight: 'bold'
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const tableSize = 7

export default function ExternalSourceHomeWidget (props) {
    const [externalSourceLogs, setExternalSourceLogs] = useState([]);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCompleteLogs();
    }, [])


    const fetchCompleteLogs = async () => {
        const url = ApiUrl.ExternalSource.getCompleteLogs.getPath;

        try {
            setLoading(true);
            const res = await fetch(url);
            const data = await handleHttpResponse(res);
            setExternalSourceLogs(data);
        } catch (err) {
            console.error("Failed to get external source logs" + err);
        } finally {
            setLoading(false);
        }
    }


    return (
        <Container>
            <TableContainer>
                <Table sx={{minWidth: 650, m: 0}} size="small">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Task Description</StyledTableCell>
                            <StyledTableCell>Imported Record</StyledTableCell>
                            <StyledTableCell>Task Time</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {externalSourceLogs?.length > 0 && externalSourceLogs.slice(0, tableSize).map( e => (
                            <StyledTableRow
                                key={e.id}
                            >
                                <TableCell>{e.description}</TableCell>
                                <TableCell component="th" scope="row">
                                    {e.importedRecordCount}
                                </TableCell>
                                <TableCell>{convertDateToTimeString(e.createdTs)}</TableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading}/>
        </Container>
    )
}
